import Flickr from "flickr-sdk";

const flickr = new Flickr("5e1ebb965be7db196a8a76ccf5c1b336", {});

export default flickr;
